import FaqHomeOne from "./FaqHomeOne";
import CtaHomeOne from "./CtaHomeOne";
import Wrapper from "@/layouts/Wrapper";
import HeroHomeOne from "./HeroHomeOne";
import AboutHomeOne from "./AboutHomeOne";
 import FeaturesHomeOne from "./FeaturesHomeOne";
import HowWeWorkHomeOne from "./HowWeWorkHomeOne";
import IntegrationHomeOne from "./IntegrationHomeOne";
import HeaderOne from "@/layouts/headers/HeaderOne";
import FooterOne from "@/layouts/footers/FooterOne";

export default function HomeOne() {
  return (
    <Wrapper>
      <HeaderOne />
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <HeroHomeOne />
           <HowWeWorkHomeOne />
          <AboutHomeOne />
          <FeaturesHomeOne />
          <IntegrationHomeOne />
          <FaqHomeOne />
          <CtaHomeOne />
          <FooterOne />
        </div>
      </div>
    </Wrapper>
  )
}
